import Api from './BaseRequest'

const Get = () => {
    return Api.Get('/api/notifications')
}

export default {
    Get
}
